import type { RouteRecordRaw } from "vue-router"

function flattenRoutes(routes: RouteRecordRaw[]): RouteRecordRaw[] {
  return routes.reduce((acc, route) => {
    acc.push(route)
    if (route.children) {
      acc.push(...flattenRoutes(route.children))
    }
    return acc
  }, [] as RouteRecordRaw[])
}

function isRouteLeaf(route: RouteRecordRaw) {
  return !route.children || route.children.length === 0
}

function isVisibleLandingRoute(route: RouteRecordRaw) {
  return route.name && !route.meta?.hidden && isRouteLeaf(route)
}

function isHqTabLandingRoute(route: RouteRecordRaw) {
  return route.name
    && route.meta?.hidden === true
    && route.meta?.hqOnly === true
    && route.meta?.showTag === true
    && isRouteLeaf(route)
}

export function findFirstAccessibleRoute(routes: RouteRecordRaw[]) {
  return flattenRoutes(routes).find(route =>
    isVisibleLandingRoute(route) || isHqTabLandingRoute(route),
  )
}
